import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-world-surveys',
  templateUrl: './world-surveys.component.html',
  styleUrls: ['./world-surveys.component.css']
})
export class WorldSurveysComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/world-surveys/world-surveys.component.ts